<mat-list>
  <ng-container *ngFor="let source of knowledgeSources">
    <mat-list-item lines="3">
      <a matListItemTitle class="knowledge-source-title" (click)="clickTitle(source)">{{ source.name }}</a>
      <span>{{ getKnowledgePreview(source) }}</span>
      <div matListItemMeta *ngIf="canRemoveSource(source)">
        <div>
          <mat-icon class="clickable" (click)="clickRemove(source)">close</mat-icon>
        </div>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>
